import { Box, Link, Typography } from "@mui/material";
import { SelectedCountry } from "../../../types/common";

const HeaderTitle = ({
  isMobile,
  country,
  onClick,
}: {
  isMobile: boolean;
  country?: SelectedCountry;
  onClick: () => void;
}) => (
  <>
    <Link
      aria-label="british-council-logo"
      href=""
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      <Box display="flex" width={{ xs: "105px", md: "140px" }}>
        <Box
          component="img"
          src="/assets/svg/British_Council.svg"
          alt="logo"
          width="100%"
          height="100%"
        />
      </Box>
    </Link>

    {!isMobile && (
      <Box display="flex" width="106px" height="40px" p="1px">
        <Box
          component="img"
          src="/assets/svg/qualification.svg"
          alt="logo"
          width="100%"
          height="100%"
        />
      </Box>
    )}

    {!!country && (
      <Typography
        color="inherit"
        fontWeight="400"
        fontSize="1.125rem"
        noWrap
        sx={{ flexGrow: 1 }}
      >
        {country.label}
      </Typography>
    )}
  </>
);

export default HeaderTitle;
